import { render, staticRenderFns } from "./BandejaInvisalingComponenteCapturar.vue?vue&type=template&id=7bf87ab0"
import script from "./BandejaInvisalingComponenteCapturar.vue?vue&type=script&lang=js"
export * from "./BandejaInvisalingComponenteCapturar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports